'use client'

import { usePDP } from '@src/hooks/usePDP'
import { useViewProductDetailPage } from '@src/utils/analytics.util'

export const PDPAnalytics = () => {
  const { viewModel } = usePDP()
  useViewProductDetailPage(viewModel?.product, viewModel?.selectedVariant)

  return null
}
